import React, { useEffect, useState } from 'react';
import { ParticleBackground } from '../components/ParticleBackground';
import { Navbar } from '../components/Navbar/Navbar';
import { Pricing } from '../components/Pricing/Pricing';
import { trackPageView } from '../firebaseConfig';
import { useMetaPixel } from '../hooks/useMetaPixel';

const PricingPage: React.FC = () => {
  const [animationPhase, setAnimationPhase] = useState(0);
  const { trackPricingView, trackStartTrial } = useMetaPixel();

  // Force scroll to top on page load
  useEffect(() => {
    // Set document title
    document.title = 'Plans & Pricing - MockTrail';
    
    // Track page view
    trackPageView('MockTrail Pricing Page', {
      page_type: 'pricing',
      product: 'mocktrail'
    });
    
    // Track Meta Pixel pricing view
    trackPricingView();
    setTimeout(() => setAnimationPhase(1), 1600); // Title and content
    // Force scroll to top on page load/refresh
    window.scrollTo(0, 0);
  }, []);

  // Custom background gradient styles
  const backgroundGradient = {
    background: 'radial-gradient(circle at 10% 20%, rgba(90, 92, 106, 0.05) 0%, rgba(32, 45, 58, 0.01) 81.3%)',
    position: 'relative' as 'relative',
    zIndex: 0,
    overflow: 'hidden' as 'hidden'
  };

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark text-text-primary-light dark:text-text-primary-dark" style={backgroundGradient}>
      {/* Animated gradient elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute top-[10%] left-[5%] w-[40%] h-[30%] rounded-full bg-primary-light/5 dark:bg-primary-dark/5 blur-[80px] animate-pulse-slow"></div>
        <div className="absolute bottom-[20%] right-[10%] w-[25%] h-[40%] rounded-full bg-secondary-light/5 dark:bg-secondary-dark/5 blur-[80px] animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-[40%] right-[30%] w-[20%] h-[20%] rounded-full bg-primary-light/3 dark:bg-primary-dark/3 blur-[80px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>
      
      <ParticleBackground />
      <Navbar />
      
      <div className="container mx-auto px-4 py-12 max-w-7xl mt-36">
        <div className={`text-center mb-12 transform transition-all duration-500 ease-out ${
          animationPhase >= 1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}>
          <h1 className="text-4xl font-heading font-bold mb-4">Plans & Pricing</h1>
          <p className="text-lg text-text-secondary-light dark:text-text-secondary-dark max-w-2xl mx-auto">
            Choose the perfect plan for your interview preparation. 
            You can upgrade anytime.
          </p>
        </div>
        
        {/* Pricing Component */}
        <Pricing />
      </div>
    </div>
  );
};

export default PricingPage; 